// ============================================================================
// STAGING-omgeving voor de Angular-frontend.
// Wordt door docker-compose.staging.yml over src/environments/environment.ts
// gemount, zodat de webapp de STAGING-URL's gebruikt i.p.v. localhost.
//
// LET OP: deze URL's zijn in de frontend "ingebakken". Kies je andere
// (sub)domeinen, pas ze hier aan en herstart de webapp-container.
//   appUrl / authUrl / apiUrl  -> jouw staging-(sub)domeinen (HTTPS)
//   storageUrl                 -> je Backblaze-bucket (publieke lees-URL)
// ============================================================================
export const environment = {
  production: false,
  appUrl: 'https://app.playstats.ai/',
  authUrl: 'https://auth.playstats.ai',
  apiUrl: 'https://api.playstats.ai',
  // 'dispatch' (realtime, dienst 'herald') draait nog niet in slice 1 —
  // placeholder; we bedraden 'm zodra herald wordt toegevoegd (slice 2).
  dispatchUrl: 'https://dispatch.playstats.ai',
  // Ondertekende links: de webapp vraagt /storage/<pad> aan de gateway, die een
  // tijdelijke Backblaze-link teruggeeft (302). Bucket blijft privé.
  storageUrl: 'https://api.playstats.ai/storage/',
  logo: '/assets/images/environments/playstats/logo.svg',
  defaultLanguage: 'en',
  availableLanguages: ['en', 'nl', 'es', 'fr'],
  appTitle: 'Provispo PlayStats',
  faviconPath: 'assets/favicon/favicon.ico',
  translateEnabled: true,
  // Nodig voor de footer-statusbalk (status-bar). Houd gelijk met
  // webapp.environment.dev.ts — een veld in maar één van de twee laat
  // `ng serve` omvallen op die omgeving (26-09-2026: Cannot GET /).
  envName: 'prod' as 'dev' | 'prod' | 'china',
  translations: {
    loginTitle: 'LOGIN_PAGE.title',
    loginContent: 'LOGIN_PAGE.content',
    footerCopyright: 'FOOTER.copyright'
  },
  // Adressen van privacybeleid en voorwaarden. Leeg = de link wordt niet
  // getoond; die pagina's bestaan nog niet.
  legalUrls: {
    privacy: '',
    terms: ''
  },
  // STAGING slice 1 — alleen de features met een draaiende backend aan.
  // De rest (live, matches, players, events/tagging, playlists, club-albums,
  // recorder-planning) wijst naar nog-niet-uitgerolde diensten en geeft
  // anders "server error". Zet ze aan zodra die diensten draaien (slice 2/3).
  permissions: {
    dashboard: true,
    clubAlbum: true,
    liveShow: true,
    recordersScheduleShow: true,
    videoShow: true,
    playersShow: true,
    matchShow: true,
    uploadRequest: true,
    eventsShowSchema: true,
    playlistsShow: true,
    usersShow: true,
    loginZh: false,
    subpanels: true,
    optionTools: true,
    exportEvent: true
  },
  routeOrder: [
    'videos',
  ],
  googleAnalyticsId: '',
  cripsWebsiteID: '5ec25ca5-355b-4ab1-ab5f-bb16cc63ba24',
};
